var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticClass:"full-screen-iframe",attrs:{"src":_vm.serviceUrl,"frameborder":"0"}})
}
var staticRenderFns = []

export { render, staticRenderFns }